module.exports = __webpack_public_path__ + "static/media/copy.76db347d.svg";